let btnIngredient = document.querySelector('.ingredients #overlay_btn')
let overlayIngredient = document.querySelector('.ingredients #img_overlay')
// bundle ingredient
let btnBundleIngredient = document.querySelectorAll('.bundle_btns .overlay_btn')



let body = document.body

// button event for image show
btnIngredient?.addEventListener("click",function(){
  openOverlay()
})
// bundle buttons for overlay open
btnBundleIngredient?.forEach(btn=>{
  btn.addEventListener('click',function(){
    const targetOverlayImg = this.parentElement.querySelector('.img_overlay')
    targetOverlayImg.classList.add('show')
    body.classList.add("bundle_overlay_opened")
  })
})

// overlay event to close overlay
document.addEventListener("click",function(e){
  if(e.target.matches('#img_overlay') || e.target.matches('.img_overlay')){
    removeOverlay()
  }
})
// escape key event to remove overlay from body
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
     if(body.classList.contains('overlay_opened') || body.classList.contains('bundle_overlay_opened')){
       removeOverlay()
     }
  }
});

document.addEventListener('click', function(event) {
  // console.log(event.target)
  if(event.target.matches('.close_icon_wrapper') || event.target.matches('.close_icon_wrapper svg') || event.target.matches('.close_icon_wrapper svg path') ){
    // console.log("event matched")
     if(body.classList.contains('overlay_opened')){
       removeOverlay()
     }
    else if (isAnyBundleOpen()){
       removeOverlay()
    }
  }
});








function removeOverlay(){
  console.log("remove overlay called")
   body.classList.remove("overlay_opened")
   body.classList.remove("bundle_overlay_opened")
    btnBundleIngredient.forEach(btn=>{
      const targetOverlayImg = btn.parentElement.querySelector('.img_overlay')
      console.log(targetOverlayImg)
      if(targetOverlayImg.classList.contains('show')){
        targetOverlayImg.classList.remove('show')
      }
      
    })
  

}
function openOverlay(){
   body.classList.add("overlay_opened")
}

function isAnyBundleOpen() {
  return Array.from(btnBundleIngredient).some(btn => {
    const targetOverlayImg = btn.parentElement.querySelector('.img_overlay');
    return targetOverlayImg && targetOverlayImg.classList.contains('show');
  });
}




